/*!

=========================================================
* Argon Dashboard React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
/*eslint-disable*/
import React from "react";
import { NavLink as NavLinkRRD, Link } from "react-router-dom";
// nodejs library to set properties for components
import { PropTypes } from "prop-types";

// reactstrap components
import {
  Collapse,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Media,
  NavbarBrand,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Container,
  Row,
  Col
} from "reactstrap";
import { Badge } from "reactstrap";

class Sidebar extends React.Component {
  state = {
    collapseOpen: false
  };
  constructor(props) {
    super(props);
    this.activeRoute.bind(this);
  }
  // verifies if routeName is the one active (in browser input)
  activeRoute(routeName) {
    return this.props.location.pathname.indexOf(routeName) > -1 ? "active" : "";
  }
  // toggles collapse between opened and closed (true/false)
  toggleCollapse = () => {
    this.setState({
      collapseOpen: !this.state.collapseOpen
    });
  };
  // closes the collapse
  closeCollapse = () => {
    this.setState({
      collapseOpen: false
    });
  };
  // creates the links that appear in the left menu / Sidebar
  createLinks = routes => {
    return routes.map((prop, key) => {
      return (
        <NavItem key={key}>
          <NavLink
            to={prop.layout + prop.path}
            tag={NavLinkRRD}
            onClick={this.closeCollapse}
            //activeclassName="active"
          >
            <i className={prop.icon} />
            {prop.name}
            {
              (prop.name === "SSMG") ?
                <Badge color="primary">New</Badge>
                :
                ""
            }

          </NavLink>
        </NavItem>
      );
    });
  };
  render() {
    const { bgColor, routes, logo } = this.props;
    let navbarBrandProps;
    if (logo && logo.innerLink) {
      navbarBrandProps = {
        to: logo.innerLink,
        tag: Link
      };
    } else if (logo && logo.outterLink) {
      navbarBrandProps = {
        href: logo.outterLink,
        target: "_blank"
      };
    }
    return (
      <Navbar
        className="navbar-vertical fixed-left navbar-light bg-white"
        expand="md"
        id="sidenav-main"
      >
        <Container fluid>
          {/* Brand */}
          {logo ? (
            <NavbarBrand className="pt-0" {...navbarBrandProps} >
              <img
                alt={logo.imgAlt}
                className="navbar-brand-img"
                src={logo.imgSrc}
              />
            </NavbarBrand>
          ) : null}
          {/* User */}
          <Nav className="align-items-center d-md-none">
            <UncontrolledDropdown nav>
              <DropdownToggle nav>
                <Media className="align-items-center">
                  <span className="avatar avatar-sm rounded-circle">
                    <img
                      alt="..."
                      src={require("assets/img/theme/team-1-800x800.jpg")}
                    />
                  </span>
                </Media>
              </DropdownToggle>
              <DropdownMenu className="dropdown-menu-arrow" right>
                <DropdownItem className="noti-title" header tag="div">
                  <h6 className="text-overflow m-0">Welcome!</h6>
                </DropdownItem>
                <DropdownItem to="/admin/user-profile" tag={Link}>
                  <i className="ni ni-single-02" />
                  <span>My profile</span>
                </DropdownItem>
                <DropdownItem to="/admin/user-profile" tag={Link}>
                  <i className="ni ni-settings-gear-65" />
                  <span>Settings</span>
                </DropdownItem>
                <DropdownItem to="/admin/user-profile" tag={Link}>
                  <i className="ni ni-calendar-grid-58" />
                  <span>Activity</span>
                </DropdownItem>
                <DropdownItem to="/admin/user-profile" tag={Link}>
                  <i className="ni ni-support-16" />
                  <span>Support</span>
                </DropdownItem>
                <DropdownItem divider />
                <DropdownItem href="#pablo" onClick={e => e.preventDefault()}>
                  <i className="ni ni-user-run" />
                  <span>Logout</span>
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          </Nav>
          {/* Collapse */}
          <Collapse navbar>
            {/* Collapse header */}
            <div className="navbar-collapse-header d-md-none">
              <Row>
                {logo ? (
                  <Col className="collapse-brand" xs="6">
                    {logo.innerLink ? (
                      <Link to={logo.innerLink}>
                        <img alt={logo.imgAlt} src={logo.imgSrc} />
                      </Link>
                    ) : (
                      <a href={logo.outterLink}>
                        <img alt={logo.imgAlt} src={logo.imgSrc} />
                      </a>
                    )}
                  </Col>
                ) : null}
              </Row>
            </div>
            
            {/* Navigation */}
            <Nav navbar>{this.createLinks(routes)}</Nav>
            {/* Divider */}
            <hr className="my-3" />
            {/* Heading */}
            <h6 className="navbar-heading text-muted">Advanced</h6>
            {/* Navigation */}
            <Nav className="mb-md-3" navbar>
              <NavItem>
                <NavLink 
                tag={NavLinkRRD}
                //activeclassName="active"
                to={"/admin/advanced/upload-students"}>
                  <i className="fa fa-users" />
                  Upload Students with Excel
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink 
                tag={NavLinkRRD}
                //activeclassName="active"
                to={"/admin/advanced/upload-bussing-report"}>
                  <i className="fa fa-bus" />
                  Upload Bussing Info with Excel
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink 
                tag={NavLinkRRD}
                //activeclassName="active"
                to={"/admin/advanced/upload-center-service-report"}>
                  <i className="fa fa-users" />
                  Upload Bacenta/Center Service with Excel
                  <Badge color="primary">New</Badge>
                </NavLink>
              </NavItem>
              </Nav>
               {/* Divider */}
              <hr className="my-3" />
              {/* Heading */}
              <h6 className="navbar-heading text-muted">Reports</h6>
              {/* Navigation */}
              <Nav className="mb-md-3" navbar>
                <NavItem>
                  <NavLink 
                  tag={NavLinkRRD}
                  onClick={this.closeCollapse}
                  //activeclassName="active"
                  to={"/admin/students/ministry-skills"}>
                    <i className="ni ni-cloud-upload-96" />
                    Generate Ministry Skills Report
                  </NavLink>
                </NavItem>
              </Nav>
              <Nav className="mb-md-3" navbar>
                <NavItem>
                  <NavLink 
                  tag={NavLinkRRD}
                  onClick={this.closeCollapse}
                  //activeclassName="active"
                  to={"/admin/students/anagkazo_live_attn"}>
                    <i className="ni ni-cloud-upload-96" />
                    Generate Attendance report
                  </NavLink>
                </NavItem>
              </Nav>
              <Nav className="mb-md-3" navbar>
                <NavItem>
                  <NavLink 
                  tag={NavLinkRRD}
                  onClick={this.closeCollapse}
                  //activeclassName="active"
                  to={"/admin/students/generate-bussing-report"}>
                    <i className="ni ni-bus-front-12" />
                    Generate Bussing Reports
                  </NavLink>
                </NavItem>
              </Nav>
              <Nav className="mb-md-3" navbar>
                <NavItem>
                  <NavLink 
                  rel="noopener noreferrer" 
                  target="_blank"
                  
                  //activeclassName="active"
                  href="https://attendance.firstlovegallery.com/">
                    <i className="ni ni-check-bold" />
                    Redirect to Academic Attendance
                  </NavLink>
                </NavItem>
              </Nav>
              <Nav className="mb-md-3" navbar>
                <NavItem>
                  <NavLink href="https://www.creative-tim.com/product/argon-dashboard-pro-react?ref=adr-admin-sidebar">
                    <i className="ni ni-bold-right" />
                    Logout
                  </NavLink>
                </NavItem>
              </Nav>
          </Collapse>
        </Container>
      </Navbar>
    );
  }
}

Sidebar.defaultProps = {
  routes: [{}]
};

Sidebar.propTypes = {
  // links that will be displayed inside the component
  routes: PropTypes.arrayOf(PropTypes.object),
  logo: PropTypes.shape({
    // innerLink is for links that will direct the user within the app
    // it will be rendered as <Link to="...">...</Link> tag
    innerLink: PropTypes.string,
    // outterLink is for links that will direct the user outside the app
    // it will be rendered as simple <a href="...">...</a> tag
    outterLink: PropTypes.string,
    // the image src of the logo
    imgSrc: PropTypes.string.isRequired,
    // the alt for the img
    imgAlt: PropTypes.string.isRequired
  })
};

export default Sidebar;
